import React from 'react';

const features = [
  {
    title: "Accurate Orbital Mechanics",
    text: "Built on classical two-body mechanics and validated astrodynamics models (Hohmann, Bi-elliptic)."
  },
  {
    title: "Instant  ΔV & Burn Analysis",
    text: "Compute transfer cost, burn sequence, and maneuver timing instantly."
  },
  {
    title: "Interactive 3D Visualization",
    text: "Inspect orbital transitions with real-time rendered trajectory paths."
  },
  {
    title: "Developer-Ready API",
    text: "Programmatic access for mission planning tools, research simulations, and space-tech applications."
  }
];

const WhyORBTXSection = () => {
  return (
    <section className="py-20 px-4">
      <div className="max-w-6xl mx-auto">

        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4">Why ORBTX?</h2>
          <p className="text-gray-400 text-lg max-w-3xl mx-auto">
            ORBTX is built for rapid mission prototyping —
            bridging the gap between quick estimates and full mission analysis suites.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-dark-800 p-8 rounded-lg border border-gray-700 hover:border-primary-500 transition"
            >
              <h3 className="text-xl font-semibold mb-3 text-primary-400">
                {feature.title}
              </h3>
              <p className="text-gray-300 leading-relaxed">
                {feature.text}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-dark-800 border-l-4 border-primary-500 p-8 rounded-r-lg">
          <h3 className="text-2xl font-bold mb-3">
            Think of ORBTX as…
          </h3>
          <p className="text-gray-300 leading-relaxed text-lg">
            <strong className="text-white">Figma for orbital mechanics.</strong>
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhyORBTXSection;